import {
  createContext,
  useContext,
  useLayoutEffect,
  type ReactNode,
} from "react";

import { setPlatformConfig } from "./platform-context";
import type { PlatformConfig } from "./types";

const PlatformContext = createContext<PlatformConfig | null>(null);

export function PlatformProvider({
  config,
  children,
}: {
  config: PlatformConfig;
  children: ReactNode;
}) {
  useLayoutEffect(() => {
    setPlatformConfig(config);
  }, [config]);

  setPlatformConfig(config);

  return (
    <PlatformContext.Provider value={config}>{children}</PlatformContext.Provider>
  );
}

export function usePlatform(): PlatformConfig {
  const config = useContext(PlatformContext);
  if (!config) {
    throw new Error("usePlatform must be used within PlatformProvider");
  }
  return config;
}
